"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_JOBS_SECTIONS = exports.DATA_FILTER_CLEAR = exports.DATA_FILTER_ERROR = exports.DATA_DETAIL_PAGE = exports.DATA_FILTER_SUBMIT = exports.DATA_JOBS_CONTAINER = exports.DATA_JOBS = void 0;
// Jobs
exports.DATA_JOBS = 'data-jobs';
exports.DATA_JOBS_CONTAINER = 'data-jobs-container';
exports.DATA_FILTER_SUBMIT = 'data-filter-submit';
exports.DATA_DETAIL_PAGE = 'data-detail-page';
exports.DATA_FILTER_ERROR = 'data-filter-error';
exports.DATA_FILTER_CLEAR = 'data-filter-clear';
exports.DATA_JOBS_SECTIONS = 'data-jobs-sections';
